import { render } from "./Section_Plot.vue?vue&type=template&id=ddb9c210"
import script from "./Section_Plot.vue?vue&type=script&lang=js"
export * from "./Section_Plot.vue?vue&type=script&lang=js"

import "./Section_Plot.vue?vue&type=style&index=0&id=ddb9c210&lang=scss"
script.render = render

export default script